import cookie from 'cookie-machine';

export function isLoggedIn() {
  const token = localStorage.getItem('token') || getCookie('token');
  return !!token;
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export function isUserHasRole(roleId) {
  const roleIdsString = cookie.get('roleIds');

  if (!roleIdsString) {
    return false;
  }

  const roleIds = roleIdsString.split(',');

  return roleIds.includes(roleId.toString());
}
